module.exports = __webpack_public_path__ + "img/horizontal_6_1_8023.eafb1343.png";